import styled, { css } from 'styled-components';

import type { Icon } from '../../theme';
import { rem } from '../../utils';

export type IconSize = keyof typeof Icon.Size;

const getSize = ({ size, theme }: { size: IconSize; theme: any }) =>
  rem(theme.Icon.Size[size] || theme.Icon.Size.Small);

export const StyledIcon = styled.i<{
  size: IconSize;
}>`
  display: inline-block;
  width: ${getSize};
  height: ${getSize};
  font-weight: normal;
  color: inherit;
  text-align: center;
`;

export const StyledSvg = styled.svg<{
  size: IconSize;
  angle?: number;
  highlightColor?: string;
  color?: string;
}>`
  display: inline-block;
  width: ${getSize};
  height: ${getSize};
  font-weight: normal;
  color: inherit;
  text-align: center;
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  ${({ theme, color, highlightColor }) => css`
    ${color &&
    css`
      color: ${color};
      fill: ${color};
    `}

    ${highlightColor &&
    css`
      &:hover {
        color: ${highlightColor};
        fill: ${highlightColor};
        transition: all ${theme.Transition.Timing.In};
      }
    `}
  `}
`;
